import { BackgroundCheckType } from '../types';

export type BackgroundCheckQuota = { [type in BackgroundCheckType]: { enabled: boolean; quota: number } };

export const backgroundCheckQuotaForm = {
    type: 'form',
    children: [
        {
            type: 'form.checkbox',
            key: 'manual.enabled',
            label: 'Manual - Quota Enabled',
        },
        {
            type: 'form.number',
            key: 'manual.quota',
            label: 'Manual - Quota Value',
            validate: {
                required: true,
            },
        },
        {
            type: 'form.checkbox',
            key: 'criminalSuper.enabled',
            label: 'Super Search - Quota Enabled',
        },
        {
            type: 'form.number',
            key: 'criminalSuper.quota',
            label: 'Super Search - Quota Value',
            validate: {
                required: true,
            },
        },
        {
            type: 'form.checkbox',
            key: 'legacySexOffender.enabled',
            label: 'Legacy Sex Offender - Quota Enabled',
        },
        {
            type: 'form.number',
            key: 'legacySexOffender.quota',
            label: 'Legacy Sex Offender - Quota Value',
            validate: {
                required: true,
            },
        },
        {
            type: 'form.checkbox',
            key: 'standard.enabled',
            label: 'Standard - Quota Enabled',
        },
        {
            type: 'form.number',
            key: 'standard.quota',
            label: 'Standard - Quota Value',
            validate: {
                required: true,
            },
        },
        {
            type: 'form.checkbox',
            key: 'cori.enabled',
            label: 'CORI - Quota Enabled',
        },
        {
            type: 'form.number',
            key: 'cori.quota',
            label: 'CORI - Quota Value',
            validate: {
                required: false,
            },
        },
        {
            type: 'form.checkbox',
            key: 'vsos.enabled',
            label: 'VSOS - Quota Enabled',
        },
        {
            type: 'form.number',
            key: 'vsos.quota',
            label: 'VSOS - Quota Value',
            validate: {
                required: true,
            },
        },
        {
            type: 'form.checkbox',
            key: 'patch.enabled',
            label: 'PATCH - Quota Enabled',
        },
        {
            type: 'form.number',
            key: 'patch.quota',
            label: 'PATCH - Quota Value',
            validate: {
                required: false,
            },
        },
        {
            type: 'form.checkbox',
            key: 'jnet.enabled',
            label: 'JNET - Quota Enabled',
        },
        {
            type: 'form.number',
            key: 'jnet.quota',
            label: 'JNET - Quota Value',
            validate: {
                required: true,
            },
        },
    ],
};

export const defaultBackgroundCheckQuota: BackgroundCheckQuota = {
    manual: {
        enabled: false,
        quota: 0,
    },
    criminalSuper: {
        enabled: true,
        quota: 0,
    },
    legacySexOffender: {
        enabled: true,
        quota: 0,
    },
    standard: {
        enabled: true,
        quota: 0,
    },
    cori: {
        enabled: false,
        quota: 0,
    },
    vsos: {
        enabled: true,
        quota: 0,
    },
    patch: {
        enabled: false,
        quota: 0,
    },
    jnet: {
        enabled: true,
        quota: 0,
    },
};
